/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Saved1Inputs */

const vi_sitesettings_saved1 = /** @type {(inputs: Sitesettings_Saved1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã lưu cài đặt website. Website cập nhật trong khoảng 1 phút.`)
};

/**

* @param {Sitesettings_Saved1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_saved1 = /** @type {((inputs?: Sitesettings_Saved1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Saved1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_saved1(inputs)
});
export { sitesettings_saved1 as "siteSettings_saved" }